
<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 20/12/2020
  -->

<template>
	<ToolTipView v-if="tooltip" :text="tooltip" :show-after="tooltipDelay" :position="tooltipPosition" :useDefaultSlotAsTrigger="true">
		<span v-if="isCircleButton"
			  class="button-circle qw-btn-background button-circle-size"
			  :class="{'el-button--primary': $attrs.primary, 'disabled': disabled}"
			  v-bind="listenersComputed">
				<QwIcon
					v-bind="qwIconAttrsComputed"
					:fontFamilyClass="fontFamilyClass"/>
		</span>

		<button v-else-if="isLinkButton" class="link-button" v-bind="listenersComputed" type="button">
			<slot></slot>
		</button>

		<el-button
			v-else
			:class="{'simple-button': isSimpleButton}"
			:size="sizeComputed"
			:is-loading="isLoading"
			:disabled="disabled"
			v-bind="listenersComputed">
			<slot></slot>
		</el-button>

	</ToolTipView>
	<span v-else-if="isCircleButton"
		  class="button-circle qw-btn-background button-circle-size"
		  :class="{'el-button--primary': $attrs.primary, 'disabled': disabled}"
		  v-bind="listenersComputed">
			<QwIcon
				v-bind="qwIconAttrsComputed"
				:fontFamilyClass="fontFamilyClass"/>
	</span>
	<button v-else-if="isLinkButton" class="link-button" v-bind="listenersComputed" type="button">
		<slot></slot>
	</button>

	<el-button
		v-else
		:class="{'simple-button': isSimpleButton}"
		:size="sizeComputed"
		:is-loading="isLoading"
		:disabled="disabled"
		v-bind="listenersComputed">
		<slot></slot>
	</el-button>
</template>

<script>

import QwBaseButton from "@/core/components/Controls/Buttons/QwBaseButton.vue";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
import QwIcon from "@/core/components/QwIcon.vue";

export default {
	name: "QwButton",
	components: {QwIcon, ToolTipView},
	extends: QwBaseButton,

	props:{
		analyticsProps: Object,
		fontFamilyClass: {String, default: "fontello"},
		circleSize: {String, default: "1.9em"},
		backgroundColor: {String, default: "#00000000"},
		tooltip: String,
		tooltipPosition: {String, default: "top"},
		tooltipDelay: {Number, default: 100},
		isLoading: Boolean,
		disabled: Boolean,
	},

    inheritAttrs: false,


	computed:{
		buttonType(){
			return this.$attrs.type
		},

		isCircleButton(){
			return this.buttonType === "circle"
		},
		isLinkButton(){
			return this.buttonType === "link"
		},
		isSimpleButton(){
			return this.$attrs.simple !== undefined
		},
        sizeComputed(){
            return this.$attrs.size || "small"
        },

		toPixelFactor(){
			if(this.circleSize.includes("em")){
				return 16
			}
			return 1
		},

		// fontSizeComputed(){
		// 	return this.circleSizeInPixels * 0.53 + "px"
		// },
		// imageSizeComputed(){
		// 	return this.circleSizeInPixels * 0.65 + "px"
		// },
		fontSizeComputed(){
			return this.circleSizeInPixels * 0.53 / 16 + "em"
		},
		imageSizeComputed(){
			return this.circleSizeInPixels * 0.65 / 16 + "em"
		},

		circleSizeInPixels(){
			return parseFloat(this.circleSize) * this.toPixelFactor
		},

		wrapperComponent() {
			return this.tooltip ? 'ToolTipView' : 'div';
		},

		qwIconAttrsComputed(){
			return {
				icon: this.$attrs.icon,
				iconImage: this.$attrs.iconImage,
				iconImageWidth: this.$attrs.iconImageWidth,
			}
		}

	}
}
</script>

<style lang="scss">

.button-circle{
	position: relative;
	display: inline-block;

	&:after{
		content: "";
		position: absolute;
		inset: 0;
		border-radius: 50%;
		background: currentColor;
		opacity: 0;
		transition: opacity 0.15s ease;
		pointer-events: none;
	}

	&:hover:after{
		opacity: 0.12;
	}

	> * {
		position: relative;
		z-index: 1;
	}
}
.simple-button{
	border: none;
}
.button-circle-size{
	width: v-bind('circleSize') !important;
	height:  v-bind('circleSize') !important;
	line-height:  v-bind('circleSize') !important;
	font-size: v-bind('fontSizeComputed') !important;

	.qw-icon-root{
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		line-height: 1;
		vertical-align: middle;
	}

	img.qw-icon-root{
		width: v-bind('imageSizeComputed') !important;
	}
}
.qw-btn-background{
	background-color: v-bind('backgroundColor');
}
</style>
